/****   request.js   ****/
// 导入axios
import axios from "axios";
import router from "@/router";
// 使用element-ui Message做消息提醒
import { Message } from "element-ui";
import store from "../store";
import { handleLoginErrorToast } from "@/assets/utils/handleData.js";
//1. 创建新的axios实例，
const service = axios.create({
  // baseURL: process.env.BASE_API,
  timeout: 30 * 1000,
});

service.defaults.baseURL =
  process.env.NODE_ENV === "production" ? "" : `http://${window.location.hostname}:8080`; //开发环境
// process.env.NODE_ENV === "production" ? "" : "http://218.201.94.133:9090/"; //测试环境
// service.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : "http://124.71.63.132"//华为云
// service.defaults.baseURL = process.env.NODE_ENV === "production" ? "" : "http://www.jujiembs.com"; //生产环境
// service.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : "http://192.168.2.34:8080"//wang
// service.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : "http://192.168.1.148:8080"//wu
// service.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : "http://192.168.20.9:8080"//xu

// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    config.data = JSON.stringify(config.data);
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
    };
    const tokenStr = window.sessionStorage.getItem("token");
    if (tokenStr) {
      config.headers["X-Authorization"] = `Bearer ${tokenStr}`;
    }
    if (config.url === "/api/auth/login") {
      config.headers["app"] = `embs`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 3.响应拦截器
service.interceptors.response.use(
  (response) => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    if (response.data.code == "00003") {
      Message.warning(handleLoginErrorToast(response.data.data));
      store.commit("SET_LOADING", false);
    }
    return response;
  },
  (error) => {
    /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      switch (error.response.status) {
        case 400:
          if (
            error.response.data.message == "Invalid password" ||
            error.response.data.message ==
              "Authentication Failed. Username or Password not valid."
          ) {
            Message.error("用户名或者密码错误!");
          } else if (
            error.response.data.message == "Invalid username" ||
            error.response.data.message == "Invalid username or phone"
          ) {
            Message.error("用户不存在!");
          } else if (
            error.response.data.message == "Current password doesn't match!"
          ) {
            Message.error("原密码错误!");
          } else {
            Message.error("服务器繁忙");
          }
          break;
        case 401:
          if (!store.state.user.lateFlag) {
            store.commit("SET_LATEFLAG", true);
            Message.error("未授权，请重新登录");
            router.push({ path: "/login" });
          }
          break;
        case 403:
          Message.error("拒绝访问");
          break;
        case 404:
          Message.error("请求错误,未找到该资源");
          // window.location.href = "/NotFound"
          break;
        case 405:
          Message.error("请求方法未允许");
          break;
        case 408:
          Message.error("请求超时");
          break;
        case 500:
          Message.error("服务器端出错");
          break;
        case 501:
          Message.error("网络未实现");
          break;
        case 502:
          Message.error("网络错误");
          break;
        case 503:
          Message.error("服务不可用");
          break;
        case 504:
          Message.error("网络超时");
          break;
        case 505:
          Message.error("http版本不支持该请求");
          break;
        default:
          Message.error(`连接错误${error.response.status}`);
      }
    } else {
      // 超时处理
      if (error.message.includes("timeout")) {
        Message.error("服务器响应超时!");
      } else {
        Message.error("服务器繁忙");
      }
    }
    store.commit("SET_LOADING", false);
    /***** 处理结束 *****/
    return Promise.resolve(error.response);
  }
);
//4.导入文件
export default service;
